import { Children, cloneElement, Component } from 'react';
import PropTypes from 'prop-types';
import withFlattenedProps from '../../../decorators/form/withFlattenedProps';

class RadioButtonGroup extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onChange: PropTypes.func,
    selectedValue: PropTypes.string,
    style: PropTypes.object,
    formFieldMeta: PropTypes.object,
    className: PropTypes.string,
  };

  state = {
    selectedValue: this.props.selectedValue || '',
  };

  componentDidUpdate(prevProps) {
    const { selectedValue } = this.props;

    if (selectedValue !== prevProps.selectedValue) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        selectedValue,
      });
    }
  }

  handleChange = (e, value) => {
    const { onChange } = this.props;

    if (onChange) {
      onChange(e);
    }

    this.setState({ selectedValue: value });
  };

  render() {
    const { style, children, name, formFieldMeta, className } = this.props;
    const { selectedValue } = this.state;

    return (
      <div className={className} style={style}>
        {Children.map(children, (child) =>
          cloneElement(child, {
            name,
            selectedValue,
            onChange: this.handleChange,
            formFieldMeta,
          }),
        )}
      </div>
    );
  }
}

export default withFlattenedProps(RadioButtonGroup);
